export default "__VITE_ASSET__F3f$jZze__"